import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";
import CabeceraSeccion from './CabeceraSeccion.jsx';
import ControlesSlider from './ControlesSlider.jsx';

// Propietats destacades de BedLoop (habitacions), amb les targetes de les
// ofertes del disseny. Només surt si el client en té.
const Destacados = ({ ruta, destacadas, elementosweb, lang }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.c-card', destacadas.length);

    if (!destacadas || destacadas.length === 0) return null;

    return (
        <section className="offers o-container">
            <CabeceraSeccion
                antetitulo={t("Nuestra selección")}
                titulo={elementosweb.subtitulo_propiedades ? elementosweb.subtitulo_propiedades[lang] : ""}
                boton={{ href: "/" + preidioma + t("buscar2"), label: t("Ver más") }}
            />
            <div className="c-cards-list c-cards-list--bedloop" ref={trackRef}>
                {destacadas.map((propiedad, index) => {
                    const href = "/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica;
                    return (
                        <article className="c-card c-card--with-price" key={index}>
                            <a href={href} className="c-card__header">
                                {
                                    propiedad.foto_principal.length != 0
                                        ? <LazyLoadImage effect='blur' threshold={10} className="image-cover" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""} />
                                        : <LazyLoadImage effect='blur' threshold={10} className="image-cover" src="/images/web/bedloop-nofoto.png" alt="" title="" />
                                }
                            </a>
                            <div className="c-card__body">
                                <div className="c-card__content">
                                    <h3 className="c-card__title">{propiedad.nombre}</h3>
                                    <p className="c-card__meta">
                                        <span><i className="fa-solid fa-bed"></i> {propiedad['num_habitaciones']}</span>
                                        <span><i className="fa-solid fa-users"></i> {propiedad['capacidad_maxima']}</span>
                                        <span><i className="fa-solid fa-bath"></i> {propiedad['num_banyos']}</span>
                                    </p>
                                </div>
                                <div className="c-card__footer">
                                    <a href={href} className="c-link">
                                        {propiedad.by_request == 1 ? t("Petición") : t("Reservar")}
                                    </a>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
            {!(navState.atStart && navState.atEnd) && (
                <ControlesSlider
                    onPrev={() => scrollByCard(-1)}
                    onNext={() => scrollByCard(1)}
                    prevDisabled={navState.atStart}
                    nextDisabled={navState.atEnd}
                />
            )}
        </section>
    );
};

export default Destacados;
